module.exports = __webpack_public_path__ + "static/media/statement-earrings.73d290e6.png";